<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="pushContext">
          <div class="pushHeader">
            <div class="alarm">
              <div class="imgWrap">
                <img src="@/assets/images/alarm.svg">
              </div>
              <div class="count">
                <span class="">{{badgeCount}}</span>
              </div>
              <h2>알림</h2>
            </div>
            <!--          <router-link to="/">-->
            <!--          <div class="closeBtn" @click="closePushList()">-->
            <!--            <img src="@/assets/images/x.svg">-->
            <!--          </div>-->
            <!--          </router-link>-->
          </div>
          <div class="pushContent">
            <ul class="listWrap">
              <li @click="callCellphone(i)" class="listItem pointer" v-for="(pushItem, i) in this.pushList" :key="i" >
                <div class="logoWrap">
                  <img src="@/assets/images/push_logo.svg">
                </div>
                <div class="content">
                  <div class="pushTitle">
                    <p class="title">{{pushItem.title}}</p>
                    <span>{{pushItem.createAt}}</span>
                  </div>
                  <p class="paragraph">{{pushItem.body}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppSidebar from '@/components/AppSidebar'
import AppHeader from '@/components/AppHeader'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getCookie } from '../../utils/cookieNew'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '알림내역',
        prevUrl: '/'
      },
      badgeCount: '',
      pushList: [],
      inactivityIndex: [],
      pushData: ''
    }
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters([
      'GET_PUSH_RESULT',
      'GET_PUSH_LIST',
      'GET_PUSH_COUNT'
    ])
  },
  created () {
    this.patchPushList()
  },
  beforeDestroy () {
    this.pushList = []
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_PUSH_COUNT'
    ]),
    ...mapActions([
      'PATCH_PUSH_READ',
      'PUSH_LIST'
    ]),
    ...mapActions('certificate', [
      'CERTIFICATE_LOOKUP_DETAIL'
    ]),
    ...mapActions('notice', [
      'NOTICE_DETAIL'
    ]),
    closePushList () {
      console.log('메인진입')
    },
    goUrl () {
      const url = 'thanq://readPush'
      document.location.href = url
    },
    async patchPushList () {
      try {
        await this.PUSH_LIST()
          .then(() => {
            this.patchData()
          })
        await this.effectionOnDisabled()
        await this.readList()
      } catch (error) {
        console.log('error :', error);
        console.log('푸쉬리스트 조회 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {

      }
    },
    async readList () {
      try {
        await this.PATCH_PUSH_READ()
      } catch (error) {
        console.log('error :', error);
        console.log('푸쉬 읽음처리 API에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    patchData () {
      const arrayHolder = []
      const InactivityArray = []
      const pushData = []
      let count = 0
      for (let i = 0; i < this.GET_PUSH_LIST.length; i++) {
        // 읽지않은 푸시 담기
        if (this.GET_PUSH_LIST[i].is_read === false) {
          InactivityArray.push(String(i))
          // 뱃지카운트 계산해
          count++
        }
        // 전체 푸시리스트 담기
        arrayHolder.push(this.GET_PUSH_LIST[i])
        // Type 값 담기
        const treasure = JSON.parse(this.GET_PUSH_LIST[i].data)
        pushData.push(treasure)
      }
      this.badgeCount = count
      this.pushList = arrayHolder
      this.inactivityIndex = InactivityArray
      this.pushData = pushData
      if (getCookie('deviceId') !== undefined) {
        this.goUrl()
      }
    },
    async effectionOnDisabled () {
      for (let i = 0; i < this.inactivityIndex.length; i++) {
        document.querySelector('.listItem').parentNode.childNodes[this.inactivityIndex[i]].classList.add('disabledItem')
      }
    },
    async callCellphone (order) {
      if ((this.pushData[order].url.indexOf('certificateLookupDetail')) !== -1) {
        await this.CERTIFICATE_LOOKUP_DETAIL(this.pushData[order].param)
      } else if ((this.pushData[order].url.indexOf('notice')) !== -1) {
        await this.NOTICE_DETAIL(this.pushData[order].param)
      }
      /* 로컬인 경우 */
      /* document.location.href = this.pushData[order].url */
      /* 개발서버인 경우 */
      /*  const dev = this.pushData[order].url.replace('https://dev.thanq.kr', '').trim()
      console.log('dev 푸시', dev)
      await this.$router.push(dev) */
      /* 리얼서버인 경우 */
      const real = this.pushData[order].url.replace('https://www.thanq.kr', '').trim()
      console.log('real 푸시', real)
      await this.$router.push(real)
    }
  },
  components: {
    AppSidebar,
    AppHeader,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
  .wholeContext .appContext {
    padding: 87px 0 50px;
  }
</style>
